const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  productInfoLoaded: 'product-info-loaded',
  sellingPlanChange: 'selling-plan-change',
  cartError: 'cart-error',
  modalToggle: 'modalToggle',
  dayNightSwitcher: 'dayNightSwitcher',
  quiz: {
    nameChange: 'quiz-name-change',
    stepsAdded: 'quiz-steps-added',
    planChange: 'quiz-plan-change',
    optionChange: 'quiz-option-change',
    productChange: 'quiz-product-change',
    tracking: {
      emailSubmit: 'Quiz Email Submit',
      nameSubmit: 'Quiz Name Submit',
      answer: 'Quiz Answer',
      quizStarted: 'Quiz Started',
      quizHalfFinished: 'Quiz Half Finished',
      quizFinished: 'Quiz Finished',
      recommendationsGenerated: 'Quiz Recommendations Generated',
    }
  }
};
